import moment from 'moment';

export const convertVisitTime = (time, format) =>
  moment(time, 'HH:mm').format(format);

export const getRecordVisitTime = (time, format) => {
  const pickerTime = convertVisitTime(time, format);

  const startRecordTime = moment.utc(pickerTime, format);

  return startRecordTime.isBefore(moment.utc(), 'day')
    ? startRecordTime.add(1, 'day').format()
    : startRecordTime.format();
};



// WEBPACK FOOTER //
// ./src/components/DashboardRecord/utils/convertVisitTime.js